import {useActiveHistoryKeyInfo} from '../../../state/panelGenHistoryKeys/useActiveHistoryKeyInfo';
import {PANEL_BANK_HIDDEN_SECTION_NAME} from '../../../util/panelbankTypes';
import {keyExistsInQueryString} from '../../../util/query-string';
import {usePanelIsActive} from '../../../util/usePanelIsActive';
import {usePanelBankConfigWithRefs} from '../hooks/usePanelBankConfigWithRefs';
import {PanelBankConfigState} from '../types';

export const useIsWorkspaceEmpty = (): boolean => {
  // Whichever history-keys query is in force here: under NGW the last step
  // comes from the sampled panel-gen query, which is the only one that runs.
  const {lastStep} = useActiveHistoryKeyInfo();
  const panelIsActive = usePanelIsActive();

  const {state: panelBankConfigState, sections: panelBankSections} =
    usePanelBankConfigWithRefs();

  // `lastStep == null` is "we don't know yet" — the query hasn't answered — so
  // hold off on the empty state until it has.
  if (
    panelBankConfigState === PanelBankConfigState.Ready ||
    lastStep == null ||
    lastStep >= 0
  ) {
    return false;
  }

  for (const [idx, section] of panelBankSections.entries()) {
    // always skip last section "Hidden Panels" unless query string is set
    if (
      section.name === PANEL_BANK_HIDDEN_SECTION_NAME &&
      idx === panelBankSections.length - 1 &&
      !keyExistsInQueryString('SHOW_HIDDEN_SECTION') // for dev debugging purposes
    ) {
      continue;
    }

    const hasAnyActivePanel = section.panels.some(panel =>
      panelIsActive({section, panel})
    );

    if (hasAnyActivePanel) {
      return false;
    }
  }

  return true;
};
